export const LIGHTMETRICS_MANUFACTURER = 'lightmetrics';
export const FALLBACK_TIME_ZONE = 'UTC';

export const MINUTE_MS = 60 * 1000;
export const DAY_MS = 24 * 60 * MINUTE_MS;

export const ACTIVITY_DAYS = 90;
export const WINDOW_MS = 5 * MINUTE_MS;
export const MIN_CLIP_MS = MINUTE_MS;
export const MAX_CLIP_MS = 5 * MINUTE_MS;
export const KEY_STEP_MS = 1000;
export const KEY_STEP_SHIFT_MS = 10 * 1000;

export const UNITS_PAGE_SIZE = 100;
export const UNITS_TARGET_COUNT = 20;
export const TRIPS_LIMIT = 100;
export const TRAILS_LIMIT = 500;
export const SEARCH_DEBOUNCE_MS = 300;


export const STALE_TIME = {
  units: 2 * MINUTE_MS,
  days: 5 * MINUTE_MS,
  trips: MINUTE_MS,
  trail: 5 * MINUTE_MS,
};

export const PRIVATE_CLIP_PERMISSION = { names: ['privatecliprequest'], subuser: [372] };

export const CLIP_LIST_QUERY_KEY = ['videoClips'];
